export default __webpack_public_path__ + "static/media/general.2f94e7ec.svg";